import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import OtherFormsServices from '../../../services/axiosServices/apiServices/OtherFormsServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import { StoreToPlantPopup } from './StoreToPlantTable';
import { decryptAES } from '../../../utils/Encryption';
import moment from 'moment';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';
import ModalBasic from '../../component/ModalBasic';
import { is } from 'date-fns/locale';
import QtyModel from './QtyModel';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class StoreToPlant extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.masterEntryServices = new MasterEntryServices();
        this.otherFormsServices = new OtherFormsServices();
        this.transactionStockServices = new TransactionStockServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isSubmitButtonLoading: false,
            isModalOpenForEditItem: false,
            isQtyModelOpen: false,
            isTable2Expanded: false,
            isInsertButtonLoading: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            requiredQtyList: [],
            invoiceRowData: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            table2Data: [],
            table2ColDefs: [],
            firstList: [],
            secondList: [],
            tempSecondList: [],
            open: false,
            isDisabledSelectItem: false,
            itemRowData: [],
            itemList2: [],
            transferObject: {
                idTransferLocation: 0,
                updateStatus: 0,
                transferNo: '001',
                date: new Date().toISOString(),
                fromList: [
                    { label: 'MANUALLY', value: 1 },
                    { label: 'BOM', value: 2 },
                ],
                idFrom: 2,
                itemList: [],
                idItem: 0,
                itemName: '',
                quantity: '',
                locationList: [],
                idLocation: 0,
                refNo: '',
                transferList: [],
                idTransfer: 0,
                refDate: new Date().toISOString(),
                remarks: '',
                deleteItemsList: [],
                drawingNo: '',
                isByPass: false
            },
            itemObject: {
                idTransferLocationDetails: 0,
                itemNameList: [],
                idItemName: 0,
                itemName: "",
                drawingNo: '',
                stock: '',
                quantity: '',
                remarks: '',
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                date: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
                itemName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "item name"
                        ),
                    },
                ],
                quantity: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "quantity"
                        ),
                    },
                ],
                idLocation: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "location"
                        ),
                    },
                ],
                idTransfer: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "transfer"
                        ),
                    },
                ],
            },
            isSelectItemPopUp: false,
            isSelectItemPopUp1: false,
            selectItemColDefs: [
                {
                    field: "drawingNo",
                    headerName: "ID",
                    minWidth: window.innerWidth * 0.15,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.25,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemCategory",
                    headerName: "Item Category",
                    minWidth: window.innerWidth * 0.06,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            selectQtyColDefs: [
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.11,
                    flex: 1.1,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.25,
                    flex: 2.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "location",
                    headerName: "Location",
                    minWidth: window.innerWidth * 0.06,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "qty",
                    headerName: "Qty",
                    minWidth: window.innerWidth * 0.05,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "requiredQty",
                    headerName: "Required Qty",
                    minWidth: window.innerWidth * 0.06,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                    valueFormatter: (params) => {
                        if (params.value == null || params.value === "") return "";
                        const num = Number(params.value);
                        return Number.isInteger(num) ? num : num.toFixed(2);
                    },
                },
                {
                    field: "stock",
                    headerName: "Stock Qty",
                    minWidth: window.innerWidth * 0.06,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "Action",
                    headerName: "Action",
                    minWidth: window.innerWidth * 0.05,
                    flex: 0.5,
                    filter: false,
                    floatingFilter: false,
                    cellClass: "action-col !p-0 flex items-center justify-center",
                    cellRenderer: (params) => (
                        <button
                            onClick={() => {
                                // if (params.data.requiredQty < params.data.stock) {
                                //     let requiredQtyList = [...this.state.requiredQtyList];
                                //     let itemRowData = [...this.state.itemRowData];

                                //     requiredQtyList = requiredQtyList.filter(
                                //         (item) => item.drawingNo !== params.data.drawingNo
                                //     );

                                //     const newItem = {
                                //         ...params.data,
                                //         quantity: params.data.requiredQty,
                                //         idItemName: params.data.idItem,
                                //         keyId: itemRowData.length + 1,
                                //     };
                                //     itemRowData.push(newItem);

                                //     this.setState({
                                //         requiredQtyList,
                                //         itemRowData,
                                //     });
                                // } else {
                                //     this.SwalServices.Alert('Required Qty is not less than Stock!')
                                // }

                                if (params.data.requiredQty <= params.data.stock) {
                                    let requiredQtyList = [...this.state.requiredQtyList];

                                    let itemObject = this.state.itemObject;
                                    itemObject.idItemName = params.data.idItem;
                                    itemObject.idItem = params.data.idItem;
                                    itemObject.itemName = params.data.itemName;
                                    itemObject.drawingNo = params.data.drawingNo;
                                    itemObject.stock = params.data.stock;
                                    itemObject.quantity = Number(params.data.requiredQty);
                                    this.setState({
                                        requiredQtyList,
                                        itemObject: itemObject,
                                        isQtyModelOpen: false
                                    });
                                } else {
                                    this.SwalServices.Alert('Required Qty is not less than Stock!')
                                }
                            }}
                            className='edit-btn w-fit p-2.5 h-[30px] flex items-center justify-center rounded-[5px]'
                        >
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    ),
                }
            ],
        }
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetDetailsFields();
        this.resetItemDetails();
        this.setState({ isModalOpen: true, open: false }, () => {
            this.getPlantList();
            this.getTransferNo();
        })
    };

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    setOpenModel4 = () => {
        this.setState({ isSelectItemPopUp1: !this.state.isSelectItemPopUp1 });
    };

    setOpenModel3 = () => {
        this.setState({ isQtyModelOpen: !this.state.isQtyModelOpen });
    };

    closePopup = () => {
        this.setState({ isModalOpen: false, });
        this.resetDetailsFields();
        this.resetItemDetails();
    };

    back = () => {
        this.setState({ open: !this.state.open });
    }

    handleChange = (event, name, field) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.transferObject;
        let itemObject = this.state.itemObject;
        if (field === 'itemObject') {
            itemObject[name] = value;
        } else {
            details[name] = value;
        }
        this.setState({ transferObject: details, itemObject: itemObject });
    }

    handleChangeForDropdown = (event, name, field) => {
        let details = this.state.transferObject;
        let itemObject = this.state.itemObject;
        let value = event.value;
        if (name === 'idItem' && field === 'transfer') {
            details.drawingNo = event.drawingNo
        }
        if (field === 'itemObject') {
            itemObject[name] = value;
        } else {
            details[name] = value;
        }
        this.setState({ transferObject: details, itemObject: itemObject }, () => {
            if (name === 'idFrom') {
                this.diassembleFrom_SelectedIndexChanged();
            }
            if (name === 'idItem' && field === 'transfer') {
                this.usp_Master_ProductReceipeSelectbyIdItemForStoreInPlant();
            }
            if (name === 'idItemName' && field === 'itemObject') {
                this.usp_Master_ItemSelectByIdItemForTransferLocationStock(details.quantity || 0);
            }
        });
    }

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idTransferLocation);
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.usp_Transaction_TransferLocationSelectById(event.data.idTransferLocation);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    handleDropdownCellClick = (event) => {
        let data = this.state.itemObject;
        data.idItemName = event.data.idItem;
        data.itemName = event.data.itemName;
        this.setState({ itemObject: data, isSelectItemPopUp: !this.state.isSelectItemPopUp }, () => {
            this.usp_Master_ItemSelectByIdItemForTransferLocationStock(data.quantity || 0);
        });
    };

    handleDropdownCellClick1 = (event) => {
        let data = this.state.transferObject;
        data.idItem = event.data.idItem;
        data.itemName = event.data.itemName;
        data.drawingNo = event.data.drawingNo;
        this.setState({ transferObject: data, isSelectItemPopUp1: !this.state.isSelectItemPopUp1 });
    };

    handleOnClick = (event, name) => {
        if (name === 'selectItemList') {
            this.setOpenModel2();
        }
        if (name === 'itemList2') {
            this.setOpenModel4();
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name, companyName: prop.companyName }, () => {
                this.procSelectAllRecordsSP();
                this.getPlantList();
                if (this.state.transferObject.idFrom === 2) {
                    this.diassembleFrom_SelectedIndexChanged();
                }
            });
        }
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Store To Plant",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            width: this.getPinnedColumnWidth(key) !== undefined ? this.getPinnedColumnWidth(key) : window.innerWidth * 0.05,
                            //pinned: ["sR.No", "jobWorkNo", "jobWorkInwardDate", "jobWorkFrom", "invoiceNo"].includes(key) ? "left" : undefined,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idTransferLocation"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Store To Plant",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id);
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "srNo": window.innerWidth * 0.04,
            "type": window.innerWidth * 0.05,
            "transferNo": window.innerWidth * 0.05,
            "date": window.innerWidth * 0.08,
            "plantDetails": window.innerWidth * 0.08,
            "drawingNo": window.innerWidth * 0.12,
            "itemName": window.innerWidth * 0.2,
            "referenceNo": window.innerWidth * 0.08,
            "referenceDate": window.innerWidth * 0.08,
            "status": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }
    getPinnedColumnWidth = (key) => {
        const colwidth = {
            // "drawingNo": window.innerWidth * 0.05,
            // "itemName": window.innerWidth * 0.2,
            // "quantity": window.innerWidth * 0.08,
            // "pendinQty": window.innerWidth * 0.08,
            // "itemRemarks": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id) => {
        let request = {
            id: id,
            formname: "Store To Plant",
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }

    getColumnWidth2 = (key) => {
        const colwidth = {
            "drawingNo": window.innerWidth * 0.11,
            "itemName": window.innerWidth * 0.2,
            "quantity": window.innerWidth * 0.06,
            "pendingQty": window.innerWidth * 0.06,
            "itemRemarks": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    getPlantList = () => {
        this.transactionStockServices.usp_Master_PlantSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    data = data.map((x) => ({
                        value: x.idPlant,
                        label: x.plantDetails,
                    }));
                }
                let transferObject = this.state.transferObject;
                transferObject.locationList = data;
                transferObject.transferList = data;
                this.setState({ transferObject: transferObject }, () => {
                });
            }
        });
    }
    getTransferNo = () => {
        let request = [this.state.idCompany, 0];
        this.otherFormsServices.usp_Transaction_TransferLocationCount(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let taxableAmt = response.responseItem.responseContent[0].count + 1;

                let formatted = '';
                if (taxableAmt.toString().length === 1) {
                    formatted = '00' + taxableAmt;
                } else if (taxableAmt.toString().length === 2) {
                    formatted = '0' + taxableAmt;
                } else {
                    formatted = taxableAmt.toString();
                }
                let transferObject = this.state.transferObject
                transferObject.transferNo = formatted
                this.setState({ transferObject: transferObject });
            }
        });
    }

    diassembleFrom_SelectedIndexChanged = () => {
        if (this.state.transferObject.idFrom === 1) {
            this.setState({ isDisabledSelectItem: true }, () => {
                this.usp_Master_ProductReceipeSelectbyIdItemForStoreInPlant();
            })
        }
        if (this.state.transferObject.idFrom === 2) {
            let itemObject = this.state.itemObject;
            itemObject.itemNameList = [];
            this.setState({ isDisabledSelectItem: false, itemObject: itemObject }, () => {
                this.usp_Master_ItemSelectForLocationTransfer();
            })
        }
    }

    usp_Master_ItemSelectForLocationTransfer = () => {
        this.otherFormsServices.usp_Master_ItemSelectForLocationTransfer(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                // if (data.length > 0) {
                //     data = data.map((x) => ({
                //         value: x.idItem,
                //         label: x.itemName,
                //         drawingNo: x.drawingNo,
                //     }));
                // }
                let transferObject = this.state.transferObject;
                transferObject.itemList = data;
                this.setState({ transferObject: transferObject }, () => {
                    //this.getProcessList();
                });
            } else {
                // this.getProcessList();
            }
        });
    }

    usp_Master_ProductReceipeSelectbyIdItemForStoreInPlant = (event, isFromClick) => {
        let request = [
            this.state.transferObject.fromList.find(x => x.value === this.state.transferObject.idFrom)?.label || '',
            this.state.transferObject.idItem,
            this.state.transferObject.updateStatus,
            this.state.transferObject.idTransferLocation,
        ];
        this.otherFormsServices.usp_Master_ProductReceipeSelectbyIdItemForStoreInPlant(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                // if (data.length > 0) {
                //     data = data.map((x) => ({
                //         value: x.idItem,
                //         label: x.itemName,
                //         itemName: x.itemName,
                //     }));
                // }
                let itemObject = this.state.itemObject;
                itemObject.itemNameList = data;
                this.setState({ itemObject: itemObject }, () => {
                    //this.getProcessList();
                    if (isFromClick && event) {
                        this.handleSetItemDetails(event);
                    }
                });
            } else {
                // this.getProcessList();
            }
        });
    }

    usp_Master_ItemSelectByIdItemForTransferLocationStock = (Quantity) => {
        let request = [
            this.state.transferObject.fromList.find(x => x.value === this.state.transferObject.idFrom)?.label || '',
            Quantity,
            this.state.itemObject.idItemName,
            this.state.transferObject.idItem,
        ];
        this.otherFormsServices.usp_Master_ItemSelectByIdItemForTransferLocationStock(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0];
                // data = data.map((x) => ({
                //     value: x.idPlant,
                //     label: x.plantDetails,
                // }));
                let itemObject = this.state.itemObject;
                itemObject.drawingNo = data.drawingNo;
                itemObject.stock = data.stock;
                itemObject.quantity = Number(data.bomQty);
                this.setState({ itemObject: itemObject }, () => {
                    //this.getProcessList();
                });
            } else {
                // this.getProcessList();
            }
        });
    }

    usp_Master_ProductReceipeSelectbyIdItemForStoreInPlantBOM = (Quantity) => {
        if (this.state.transferObject.idItem > 0 && this.state.transferObject.quantity > 0) {
            let request = [
                this.state.transferObject.idItem,
                this.state.transferObject.updateStatus,
                this.state.transferObject.idTransferLocation,
                this.state.transferObject.quantity,
            ];
            this.otherFormsServices.usp_Master_ProductReceipeSelectbyIdItemForStoreInPlantBOM(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    let { itemRowData } = this.state;

                    let filteredData = data.filter(
                        (item) => !itemRowData.some((row) => row.idItem === item.idItem)
                    );

                    this.setState({
                        requiredQtyList: filteredData,
                        isQtyModelOpen: true
                    });
                }
            });
        }
    }

    usp_Master_ProductReceipeSelectbyIdItemForStoreInPlantBOM_Print = () => {
        if (this.state.transferObject.idItem > 0 && this.state.transferObject.quantity > 0) {
            let request = [
                this.state.transferObject.idItem,
                this.state.transferObject.updateStatus,
                this.state.transferObject.idTransferLocation,
                this.state.transferObject.quantity,
            ];
            this.otherFormsServices.usp_Master_ProductReceipeSelectbyIdItemForStoreInPlantBOM_Print(request).then((response) => {
                if (response.status == 200 && response !== null) {
                    var file = new Blob([response.data], { type: "application/pdf" });

                    var fileURL = URL.createObjectURL(file);

                    window.open(fileURL, "_blank");

                    this.setState({
                        isModalOpen: false
                    });
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }
    }

    insert = (isFor) => {
        if (this.state.isInsertButtonLoading) {
            return;
        }
        if (this.state.itemObject.idItemName > 0 && Number(this.state.itemObject.quantity) > 0) {
            this.setState({ isInsertButtonLoading: true }, () => {

                let itemObject = this.state.itemObject;
                let itemListRowData = [...this.state.itemRowData];

                let object = {
                    idTransferLocationDetails: itemObject.idTransferLocationDetails,
                    idItemName: itemObject.idItemName,
                    itemName: itemObject.itemName,
                    drawingNo: itemObject.drawingNo,
                    stock: itemObject.stock,
                    quantity: Number(itemObject.quantity),
                    remarks: itemObject.remarks,
                    idItem: itemObject.idItem,
                };

                const isExist = itemListRowData.some(
                    (x) => x.idItemName === object.idItemName
                );

                if (isExist && isFor !== "Update") {
                    this.SwalServices.Error("This item already exists.");
                    this.setState({ isInsertButtonLoading: false });
                    return;
                }

                if (isFor === "Update" && itemObject.keyId) {
                    itemListRowData[itemObject.keyId - 1] = object;
                } else {
                    itemListRowData.push(object);
                }

                itemListRowData = itemListRowData.map((x, key) => ({
                    ...x,
                    keyId: key + 1
                }));

                this.setState(
                    { itemRowData: itemListRowData },
                    () => {
                        this.resetItemDetails();
                        this.setState({ isInsertButtonLoading: false });
                    }
                );

            });
        } else {
            this.SwalServices.Error("Please enter valid Item and Quantity.");
        }
    };

    resetDetailsFields = () => {
        let transferObject = this.state.transferObject;
        transferObject.idTransferLocation = 0;
        transferObject.updateStatus = 0;
        transferObject.transferNo = '001';
        transferObject.date = moment(new Date().toISOString()).format('YYYY-MM-DD'); //new Date().toISOString().format('YYYY-MM-DD'); new Date().toISOString(),
        // transferObject.itemList = [];
        transferObject.idItem = 0;
        transferObject.quantity = '';
        transferObject.itemName = '';
        //transferObject.locationList = [];
        transferObject.idLocation = 0;
        transferObject.refNo = '';
        //transferObject.transferList = [];
        transferObject.idTransfer = 0;
        transferObject.drawingNo = '';
        transferObject.refDate = moment(new Date().toISOString()).format('YYYY-MM-DD');
        transferObject.remarks = '';
        transferObject.isByPass = false;
        transferObject.deleteItemsList = [];
        this.setState({
            transferObject: transferObject, itemRowData: []
        });
    }

    resetItemDetails = () => {
        let data = this.state.itemObject;
        data.keyId = 0;
        data.idTransferLocationDetails = 0;
        data.idItemName = 0;
        data.itemName = '';
        data.drawingNo = '';
        data.stock = '';
        data.quantity = '';
        data.remarks = '';
        this.setState({
            itemObject: data
        });
    }

    deleteItem = (keyId) => {
        let data = this.state.transferObject;
        let idTransferLocationDetails = this.state.itemRowData?.find(item => item.keyId == keyId)?.idTransferLocationDetails;
        let filterData = this.state.itemRowData?.filter(item => item.keyId !== keyId);
        if (filterData.length > 0) {
            filterData.map((x, key) => {
                x.keyId = key + 1;
            });
        }
        //data.itemList = filterData;
        if (idTransferLocationDetails > 0) {
            data.deleteItemsList.push(idTransferLocationDetails);
        }
        this.setState({ transferObject: { ...data }, itemRowData: filterData }, () => {
            this.resetItemDetails();
        });
    }

    handleCellClickItemList = (event) => {
        this.resetItemDetails();
        this.usp_Master_ProductReceipeSelectbyIdItemForStoreInPlant(event, true);

        // let itemObject = this.state.itemRowData[event.data.keyId - 1];
        // let data = this.state.itemObject;
        // data.keyId = itemObject.keyId;
        // data.idTransferLocationDetails = itemObject.idTransferLocationDetails;
        // data.idItemName = itemObject.idItemName;
        // data.itemName = data.itemNameList.find(x => x.idItem === itemObject.idItemName)?.itemName;
        // data.drawingNo = itemObject.drawingNo;
        // data.stock = itemObject.stock;
        // data.quantity = Number(itemObject.quantity);
        // data.remarks = itemObject.remarks;

        // //data.idMaterialPlanning = itemData.idMaterialPlanning || 0;
        // //data.idWorkPlanningItems = itemData.idWorkPlanningItems || 0;

        // this.setState({ itemObject: data }, () => {
        //     // if (this.state.transferObject.idFrom === 1) {
        //     this.usp_Master_ProductReceipeSelectbyIdItemForStoreInPlant();
        //     // }
        //     //this.usp_Transaction_MaterialPlanningSelectbyIDWorkOrder();
        //     //this.getMaster_ItemSelectbyItemType(this.state.itemObject.itemType);
        // });
    };

    handleSetItemDetails = (event) => {
        let itemObject = this.state.itemRowData.find(
            (x) => x.idItem === event.data.idItem
        );
        let data = this.state.itemObject;
        data.keyId = itemObject.keyId;
        data.idTransferLocationDetails = itemObject.idTransferLocationDetails;
        data.idItemName = itemObject.idItemName;
        data.itemName = data.itemNameList.find(x => x.idItem === itemObject.idItemName)?.itemName;
        data.drawingNo = itemObject.drawingNo;
        data.stock = itemObject.stock;
        data.quantity = Number(itemObject.quantity);
        data.remarks = itemObject.remarks;
        this.setState({ itemObject: data })
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.transferObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    submit = () => {
        if (this.state.itemRowData.length === 0) {
            this.SwalServices.Error("Please add item details.");
            return;
        }
        let isValid = this.isValidAllFields();
        if (isValid) {
            if (this.state.transferObject.idLocation === this.state.transferObject.idTransfer) {
                this.SwalServices.Error("Location and Transfer location cannot be same.");
                return;
            }
            this.setState({ isSubmitButtonLoading: true })
            let details = this.state.transferObject;

            let requestData = {
                idTransferLocation: details.idTransferLocation,
                updateStatus: details.updateStatus,
                date: details.date,
                type: details.fromList.find(x => x.value === details.idFrom)?.label || '',
                idItem: details.idItem,
                quantity: details.quantity,
                idPlantLocation: details.idLocation,
                idPlantLocationToTransfer: details.idTransfer,
                referenceNo: details.refNo,
                referenceDate: (details.refDate && details.refDate !== 'Invalid date') ? details.refDate : null,
                remarks: details.remarks,
                isUpdated: 1,
                updatedDate: new Date().toISOString(),
                u_IdUser: this.state.idUser,
                idCompany: this.state.idCompany,
                e_Date: new Date().toISOString(),
                e_IdUser: this.state.idUser,
                itemList: [],
                deleteItemsList: details.deleteItemsList,
                isByPass: details.isByPass
            };

            // this.state.itemRowData?.map((x) => {
            //     x.idItem = x.idItemName;
            //     x.itemRemarks = x.remarks;
            // });
            let itemRowData = this.state.itemRowData;
            itemRowData?.map((x) => {
                x.idItem = x.idItemName;
                x.itemRemarks = x.remarks;
                x.idtransferlocation = x.idtransferlocation ? x.idtransferlocation : 0
                x.idTransferLocationDetails = x.idTransferLocationDetails ? x.idTransferLocationDetails : 0
            });
            requestData.itemList = itemRowData;

            requestData.itemList2 = this.state.itemList2;
            this.otherFormsServices
                .usp_Transaction_TransferLocationInsertUpdate(requestData)
                .then((response) => {
                    if (response.statusCode === 200 && response.responseItem !== null) {
                        let dynamicData = response.responseItem.responseContent;
                        if (dynamicData?.errorType === "Exists") {
                            this.SwalServices.Warning(dynamicData.errorMessage);
                            this.setState({ isSubmitButtonLoading: false })
                        } else {
                            if (details.updateStatus === 1) {
                                this.SwalServices.Success("Updated successfully.");
                                this.setState({ isSubmitButtonLoading: false })
                            } else {
                                this.SwalServices.Success("Saved successfully.");
                                this.setState({ isSubmitButtonLoading: false })
                            }
                            this.resetDetailsFields();
                            this.resetItemDetails();
                            //this.resetWorkObjectDetails();
                            //this.resetWorkPlanningObject();
                            this.setState({ isModalOpen: false }, () => {
                                this.procSelectAllRecordsSP();
                            });
                        }
                    } else {
                        this.setState({ isModalOpen: false }, () => {
                            this.SwalServices.Error(response.message);
                            this.procSelectAllRecordsSP();
                            this.setState({ isSubmitButtonLoading: false })
                        });
                    }
                })
                .catch((err) => {
                    this.SwalServices.Error("Something went wrong: " + err.message);
                    this.setState({ isSubmitButtonLoading: false })
                });
        }
    };

    usp_Transaction_TransferLocationSelectById = (id) => {
        if (id > 0) {
            this.otherFormsServices.usp_Transaction_TransferLocationSelectById(id).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0][0];
                    let res2 = response.responseItem.responseContent[1];
                    let res3 = response.responseItem.responseContent[2];

                    let transferObject = this.state.transferObject;

                    transferObject.idTransferLocation = res.idTransferLocation;
                    transferObject.updateStatus = 1;
                    transferObject.transferNo = res.transferNo;
                    transferObject.date = moment(res.date).format('YYYY-MM-DD') ?? '';
                    // transferObject.fromList = [
                    //     // { label= 'MANUALLY'; value= 1 };
                    //     // { label= 'BOM'; value= 2 };
                    // ];
                    transferObject.idFrom = transferObject.fromList.find(x => x.label === res.type)?.value;
                    //transferObject.itemList = [];
                    transferObject.idItem = res.idItem;
                    transferObject.itemName = res.idItem ? transferObject.itemList.find(x => x.value === res.idItem)?.label : '';
                    transferObject.quantity = res.quantity;
                    transferObject.drawingNo = res.idItem ? transferObject.itemList.find(x => x.value === res.idItem)?.drawingNo : '';
                    //// transferObject.locationList = [];
                    transferObject.idLocation = res.idPlantLocation;
                    transferObject.refNo = res.referenceNo;
                    //// transferObject.transferList = [];
                    transferObject.idTransfer = res.idPlantLocationToTransfer;
                    transferObject.refDate = moment(res.referenceDate).format('YYYY-MM-DD') ?? '';
                    transferObject.remarks = res.remarks;
                    transferObject.deleteItemsList = [];
                    transferObject.isByPass = res.isByPass;
                    this.getItemMasterSelectbyID(res.idItem)
                    let itemListRowData = [];
                    res2?.map((x) => {
                        let object = {
                            // drawingNo: x.drawingNo,
                            // itemType: x.itemType || "",
                            // idItem: x.idItem || x.idItem,
                            // itemName: x.itemName || x.itemName,
                            // quantity: Number(x.quantity) || 0,
                            // itemRemarks: x.itemRemarks || "",
                            // idMaterialPlanning: x.idMaterialPlanning || 0,
                            // idWorkPlanningItems: x.idWorkPlanningItems || 0
                            idTransferLocationDetails: x.idTransferLocationDetails,
                            //itemNameList: [],
                            idItemName: x.idItem,
                            idItem: x.idItem,
                            itemName: x.itemName,
                            drawingNo: x.drawingNo,
                            stock: x.stock,
                            quantity: x.quantity,
                            remarks: x.itemRemarks,
                        };
                        itemListRowData.push(object);
                    });
                    itemListRowData?.map((x, key) => {
                        x.keyId = key + 1;
                    });
                    //transferObject.itemList = itemListRowData;
                    let itemData2 = [];
                    if (transferObject.idFrom === 2) {
                        itemData2 = res3;
                    }
                    this.setState({
                        transferObject: transferObject,
                        itemRowData: itemListRowData,
                        itemList2: itemData2,
                        isModalOpen: true,
                    }, () => {
                        this.diassembleFrom_SelectedIndexChanged();
                        this.usp_Master_ProductReceipeSelectbyIdItemForStoreInPlant()
                    });
                }
            });
        }
    };

    getItemMasterSelectbyID = (id) => {
        this.masterEntryServices.getItemMasterSelectbyID(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                let transferObject = this.state.transferObject;
                transferObject.drawingNo = res.drawingNo;
                transferObject.itemName = res.itemName;
                this.setState({
                    transferObject: transferObject,
                });
            }
        });
    }

    removeStockFromItemRowData = (params) => {
        const { data } = params;
        const { itemRowData } = this.state;

        const updatedItemRowData = itemRowData.filter(
            (item) => item.idItemName !== data.idItemName
        );

        this.setState({ itemRowData: updatedItemRowData });
    }

    handleChangeForCheckBox = (event, name) => {
        let obj = this.state.transferObject;
        obj[name] = event.target.checked ? 1 : 0;
        this.setState({ transferObject: obj });
    }

    render() {
        return (
            <>
                <div className='store-to-plant'>
                    <div className='data-display'>
                        <div className='data-display-inner relative'>
                            <ButtonGrp buttons={['add', 'print']}
                                onClickHandlers={{
                                    add: () => this.openPopUpForAddingItem(),
                                    // update: () => this.openPopUpForUpdateItem(),
                                    print: this.handlePrint,
                                }}
                            />
                            <StoreToPlantPopup
                                isModalOpen={this.state.isModalOpen}
                                setOpenModel={this.setOpenModel.bind(this)}
                                transferObject={this.state.transferObject}
                                itemObject={this.state.itemObject}
                                handleChange={this.handleChange.bind(this)}
                                close={this.closePopup.bind(this)}
                                submit={this.submit.bind(this)}
                                validState={this.state.validState}
                                itemRowData={this.state.itemRowData}
                                handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                                // addWorkOrder={this.addWorkOrder.bind(this)}
                                // addProduct={this.addProduct.bind(this)}
                                back={this.back.bind(this)}
                                open={this.state.open}
                                // firstList={this.state.firstList}
                                // secondList={this.state.secondList}
                                // handleCellClickfirstList={this.handleCellClickfirstList.bind(this)}
                                isDisabledSelectItem={this.state.isDisabledSelectItem}
                                insert={this.insert.bind(this)}
                                handleCellClickItemList={this.handleCellClickItemList.bind(this)}
                                deleteItem={this.deleteItem.bind(this)}
                                handleOnClick={this.handleOnClick.bind(this)}
                                calcRequiredQty={this.usp_Master_ProductReceipeSelectbyIdItemForStoreInPlantBOM.bind(this)}
                                removeStockFromItemRowData={this.removeStockFromItemRowData.bind(this)}
                                handleChangeForCheckBox={this.handleChangeForCheckBox.bind(this)}
                                isInsertButtonLoading={this.state.isInsertButtonLoading}
                                isSubmitButtonLoading={this.state.isSubmitButtonLoading}
                                usp_Master_ProductReceipeSelectbyIdItemForStoreInPlantBOM_Print={this.usp_Master_ProductReceipeSelectbyIdItemForStoreInPlantBOM_Print.bind(this)}
                            />
                            <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                    <div className="table-inner">
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Store to plant</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.rowData}
                                        rowHeight={this.state.rowHeight}
                                        columnDefs={this.state.colDefs}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onRowDoubleClicked={this.onRowDoubleClicked}
                                        onGridReady={this.onGridReady}
                                        onCellClicked={this.handleCellClick}
                                        overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                        overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    />
                                </div>
                            </div>

                            <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                    <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.table2Data}
                                        columnDefs={this.state.table2ColDefs}
                                        rowHeight={this.state.rowHeight}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onGridReady={this.onGridReady}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.itemObject.itemNameList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                />
                <SelectItemListPopUp
                    modalName={"Select Item FOr Transfer Details"}
                    selectItemList={this.state.transferObject.itemList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp1}
                    setOpenModel={this.setOpenModel4.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick1}
                />
                <QtyModel
                    isModalOpen={this.state.isQtyModelOpen}
                    setOpenModel={this.setOpenModel3.bind(this)}
                    requiredQtyList={this.state.requiredQtyList}
                    colDefs={this.state.selectQtyColDefs}
                />
            </>
        )
    }
}